import script from "./IdlePage.vue?vue&type=script&setup=true&lang=js"
export * from "./IdlePage.vue?vue&type=script&setup=true&lang=js"

import "./IdlePage.vue?vue&type=style&index=0&id=45d63df5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45d63df5"]])

export default __exports__